import React from "react";
import Image from "./../../assets/blog_image_3-375x211.jpg";
import { FaLink, FaSearch } from "react-icons/fa";

const Card = () => {
  return (
    <div className="group relative max-w-[330px] overflow-hidden bg-white pt-[5px] px-[5px] rounded-[8px] h-full">
      <div className="max-h-[200px] relative overflow-hidden">
        <img 
          src={Image} 
          alt="" 
          className="object-cover transform group-hover:scale-110 transition-transform duration-300 ease-in-out" 
        />
        <div className="absolute w-full top-0 h-full bg-[#000] bg-opacity-30 flex justify-center items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="rounded-full flex justify-center items-center p-2 text-xl text-white border">
        <FaSearch size={20} />
          </div>
          <div className="rounded-full flex justify-center items-center p-2 text-xl text-white border">
          <FaLink size={20} />
          </div>
        </div>
      </div>
      <div className="p-2 pb-6">
        <p className="font-rubik font-bold hover:text-primary">
          At Solmen va Essern Neceasi the Angleso Grammatica
        </p>
        <div className="flex items-center gap-2 my-1">
          <p className="font-rubik text-sm font-normal text-[#b0b8bf]">
            February 15, 2023
          </p>
          <div className="h-[15px] w-[1px] bg-[#b0b8bf]" />
          <p className="font-rubik text-sm font-normal text-[#b0b8bf]">
            No Comments Yet
          </p>
        </div>
        <p className="text-[13px] font-rubik">
          Even the all-powerful Pointing has no control about the blind texts it
          is an almost unorthographic l...
        </p>
      </div>
    </div>
  );
};

export default Card;
